import { Alert, Box, Text } from '@factorialco/deprecated-design-system'
import { CardDetailFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

export const RejectionReason: React.FC<{ card: CardDetailFragment }> = ({ card }) => {
  if (!card.approval?.reason) {
    return null
  }

  return (
    <Box gap="s8" width="full">
      <Text.Normal>{i18n.t('settings.approvals.rejection_reason')}</Text.Normal>
      <Alert color="warning">{card.approval.reason}</Alert>
    </Box>
  )
}
